import openFoodFactsPolicyJson from "./openfoodfacts.json";
import usdaBrandedPolicyJson from "./usda-branded.json";
import usdaSrFoundationPolicyJson from "./usda-sr-foundation.json";
import usdaSurveyPolicyJson from "./usda-survey.json";
import {
  sourceFamilyCrosswalkSchema,
  sourceTagCrosswalkSchema,
  type SourceFamilyCrosswalk,
  type SourceTagCrosswalk,
} from "../crosswalk-schema";
import type { FoodCategoryPolicyRule } from "../policy-evaluator";

type SourceFamilyPolicy = {
  source: string;
  taxonomyVersion: string;
  status: string;
  highRiskOverrideSourceIds: string[];
  rules: FoodCategoryPolicyRule[];
  textRefinementRules?: SourceFamilyCrosswalk["textRefinementRules"];
};

type SourceTagPolicy = {
  source: string;
  taxonomyVersion: string;
  status: string;
  ignoreSourceIds: string[];
  highRiskOverrideSourceIds: string[];
  rules: FoodCategoryPolicyRule[];
  textRefinementRules?: SourceTagCrosswalk["textRefinementRules"];
};
function createSourceFamilyPolicy(crosswalk: SourceFamilyCrosswalk): SourceFamilyPolicy {
  return {
    source: crosswalk.source,
    taxonomyVersion: crosswalk.taxonomyVersion,
    status: crosswalk.status,
    highRiskOverrideSourceIds: crosswalk.highRiskOverrideSourceIds,
    rules: crosswalk.rules,
    textRefinementRules: crosswalk.textRefinementRules,
  };
}

function createSourceTagPolicy(crosswalk: SourceTagCrosswalk): SourceTagPolicy {
  return {
    source: crosswalk.source,
    taxonomyVersion: crosswalk.taxonomyVersion,
    status: crosswalk.status,
    ignoreSourceIds: crosswalk.ignoreSourceIds,
    highRiskOverrideSourceIds: crosswalk.highRiskOverrideSourceIds,
    rules: crosswalk.rules,
    textRefinementRules: crosswalk.textRefinementRules,
  };
}

export namespace FoodCategoryCrosswalkPolicy {
  export type BuiltInFoodCategoryCrosswalk = SourceTagCrosswalk | SourceFamilyCrosswalk;

  export const builtInFoodCategoryCrosswalkPolicies = {
    offTopUsTagsV1: sourceTagCrosswalkSchema.parse(openFoodFactsPolicyJson),
    usdaBrandedV1: sourceFamilyCrosswalkSchema.parse(usdaBrandedPolicyJson),
    usdaSurveyV1: sourceFamilyCrosswalkSchema.parse(usdaSurveyPolicyJson),
    usdaSrFoundationV1: sourceFamilyCrosswalkSchema.parse(usdaSrFoundationPolicyJson),
  } as const satisfies Record<string, BuiltInFoodCategoryCrosswalk>;

  export const sourceLensPolicies = {
    offTopUsTagsV1: createSourceTagPolicy(builtInFoodCategoryCrosswalkPolicies.offTopUsTagsV1),
    usdaBrandedV1: createSourceFamilyPolicy(builtInFoodCategoryCrosswalkPolicies.usdaBrandedV1),
    usdaSurveyV1: createSourceFamilyPolicy(builtInFoodCategoryCrosswalkPolicies.usdaSurveyV1),
    usdaSrFoundationV1: createSourceFamilyPolicy(
      builtInFoodCategoryCrosswalkPolicies.usdaSrFoundationV1,
    ),
  } as const satisfies Record<string, SourceFamilyPolicy | SourceTagPolicy>;

  export type BuiltInFoodCategoryCrosswalkId = keyof typeof builtInFoodCategoryCrosswalkPolicies;
}
